import { Action, createReducer, on } from '@ngrx/store';
import * as Actions from './init-flow.actions';
import { InitFlow } from '@core/models/swagger/initFlow';

export interface State {
  initFlow: InitFlow | null;
}

export const featureKey = 'flowDataInitFlow';

export const initialState: State = {
  initFlow: null,
};

export function initFlowReducer(state: State | undefined, action: Action): State {
  return createReducer(
    initialState,
    on(Actions.ResetInitFlow, (state, {}) => ({
      ...state,
      initFlow: null,
    })),
    on(Actions.UpdateInitFlow, (state, { data }) => ({
      ...state,
      initFlow: data,
    }))
  )(state, action);
}
